module.exports = __webpack_public_path__ + "img/reports_net_worth.88217a44.png";